import { useCallback, useContext, useRef, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { SettingsContext } from "../../../contexts/SettingsContext";
import { useInviteStatus } from "../invite/useInviteStatus";
import { useOrder } from "./useOrder";
import { ISpotOrderParams, ICancelSpotOrderParams } from "./useSpotOrder.types";
import { placeSpotOrderImpl } from "./useSpotOrder.place";
import {
  cancelSpotOrderImpl,
  cancelSpotOrdersBatchImpl,
} from "./useSpotOrder.cancel";

export const useSpotOrder = () => {
  const { account, masterAccount } = useContext(AuthContext);
  // The same standing max-slippage preference the perp paths read.
  const { slippageBps } = useContext(SettingsContext);
  const { data: inviteStatus } = useInviteStatus();
  const [isLoading, setIsLoading] = useState(false);
  const walletTransactionInFlightRef = useRef(false);
  const { revalidateOrdersSoon } = useOrder();

  const placeSpotOrder = useCallback(
    (params: ISpotOrderParams) =>
      placeSpotOrderImpl(params, {
        account,
        masterAccount,
        inviteStatus,
        slippageBps,
        walletTransactionInFlightRef,
        setIsLoading,
        revalidateOrdersSoon,
      }),
    [account, masterAccount, inviteStatus, revalidateOrdersSoon, slippageBps]
  );

  const cancelSpotOrder = useCallback(
    (params: ICancelSpotOrderParams) =>
      cancelSpotOrderImpl(params, {
        account,
        inviteStatus,
        walletTransactionInFlightRef,
        setIsLoading,
        revalidateOrdersSoon,
      }),
    [account, inviteStatus, revalidateOrdersSoon]
  );

  const cancelSpotOrdersBatch = useCallback(
    (spotOrders: Parameters<typeof cancelSpotOrdersBatchImpl>[0]) =>
      cancelSpotOrdersBatchImpl(spotOrders, { account, revalidateOrdersSoon }),
    [account, revalidateOrdersSoon]
  );

  return { placeSpotOrder, cancelSpotOrder, cancelSpotOrdersBatch, isLoading };
};
